import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { store, persistor } from '../Redux/store';
import { RESET_ALL_STATES } from '../Redux/actions/actions';

const AUTH_TOKEN_STORAGE_KEY = 'residentPortalToken';

const getStoredToken = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.sessionStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
};

const setStoredToken = (token) => {
  if (typeof window === 'undefined' || !token) {
    return;
  }

  window.sessionStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
  debugger;
};

const clearStoredToken = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
};

const isTokenExpired = (token) => {
  if (!token) {
    return true;
  }

  try {
    const decodedToken = jwtDecode(token);
    if (!decodedToken?.exp) {
      return false;
    }

    return decodedToken.exp * 1000 <= Date.now();
  } catch (error) {
    // Cannot decode — token format unknown, let the request through
    return false;
  }
};

const logoutExpiredSession = () => {
  clearStoredToken();
  store.dispatch({ type: 'LOGOUT' });
  store.dispatch({ type: RESET_ALL_STATES });
  persistor.purge();

  if (typeof window !== 'undefined' && window.location.pathname !== '/') {
    window.location.assign('/');
  }
};

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_RESIDENT_PORTAL_MIDDLEWARE_HOST,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    config.headers = config.headers || {};
    const token = getStoredToken();
    debugger;
    if (token) {
      if (isTokenExpired(token)) {
        logoutExpiredSession();
        return Promise.reject(new Error('ID token expired'));
      }
      else {
        config.headers['X-Authorization'] = `Bearer ${token}`;
      }
    }
       

    config.headers['Authorization'] = `Basic ${btoa('resident:WNlIC9EZXZpY2V')}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle errors globally
apiClient.interceptors.response.use(
  (response) => {
    debugger;
    const shouldStoreToken = response?.config?.url?.includes('/esignet/exchangeAutheCode');
    if (shouldStoreToken) {
      const extracted = response?.data
      if (extracted) {
        setStoredToken(extracted);
      }
    }

    return response;
  },
  (error) => {
    debugger;
    // You can handle global errors here, like 401 unauthorized
    if (error.response && error.response.status === 401) {
      logoutExpiredSession();
    }
    return Promise.reject(error);
  }
);

export default apiClient;
